(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2890,5467,4266],{

/***/ 9521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./src/components/Shared/BreadCrumbs.js
var BreadCrumbs = __webpack_require__(5467);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/Home/singleCountry/index.module.scss
var index_module = __webpack_require__(9324);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./src/components/helpers/functions.js
var functions = __webpack_require__(7819);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(1608);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./src/assets/images/svg/download.svg
var download = __webpack_require__(1476);
// EXTERNAL MODULE: ./src/assets/images/svg/expand.svg
var expand = __webpack_require__(7571);
// EXTERNAL MODULE: ./src/assets/images/svg/sar.svg
var sar = __webpack_require__(5175);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Shared/RequestForm.js
var RequestForm = __webpack_require__(4266);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Home/singleCountry/index.js















function SingleCountry(_ref) {
  var _data$name, _data$title, _data$description, _data$personnels, _data$personnels2;

  var data = _ref.data;

  var _useIntl = (0,useIntl/* default */.Z)(),
      locale = _useIntl.locale;

  var _useState = (0,react.useState)(""),
      expandedImage = _useState[0],
      setExpandedImage = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isRequestOpen = _useState2[0],
      setIsRequestOpen = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      selectedPerson = _useState3[0],
      setSelectedPerson = _useState3[1];

  var handlePdfDownload = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(item) {
      var _item$name, _item$name2;

      var pdfUrl, response, blob, link;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pdfUrl = item === null || item === void 0 ? void 0 : (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.file;
              _context.next = 3;
              return fetch(pdfUrl);

            case 3:
              response = _context.sent;
              _context.next = 6;
              return response.blob();

            case 6:
              blob = _context.sent;
              link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = "".concat(item === null || item === void 0 ? void 0 : (_item$name2 = item.name) === null || _item$name2 === void 0 ? void 0 : _item$name2.ar, ".pdf");
              link.click();
              window.URL.revokeObjectURL(link.href);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handlePdfDownload(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleExpandImage = function handleExpandImage(item) {
    var _item$name3;

    var imageUrl = (0,functions/* handleImageLink */.Iz)(item === null || item === void 0 ? void 0 : (_item$name3 = item.name) === null || _item$name3 === void 0 ? void 0 : _item$name3.pdfImage);
    if (!imageUrl) return;
    setExpandedImage(imageUrl);
  };

  var handleOpenRequestModal = function handleOpenRequestModal(person) {
    setSelectedPerson(person);
    setIsRequestOpen(true);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (index_module_default()).countryPage,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: data !== null && data !== void 0 && data.title && data !== null && data !== void 0 && data.description ? "top d-flex align-items-center gap-4" : "top d-flex align-items-center gap-4 justify-content-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "img",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: (0,functions/* handleImageLink */.Iz)(data === null || data === void 0 ? void 0 : data.image) || "",
          alt: "",
          width: 100,
          height: 100
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: data === null || data === void 0 ? void 0 : (_data$name = data.name) === null || _data$name === void 0 ? void 0 : _data$name[locale]
        })]
      }), (data === null || data === void 0 ? void 0 : data.title) && (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "info",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          children: data === null || data === void 0 ? void 0 : (_data$title = data.title) === null || _data$title === void 0 ? void 0 : _data$title[locale]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: data === null || data === void 0 ? void 0 : (_data$description = data.description) === null || _data$description === void 0 ? void 0 : _data$description[locale]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "personnels",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
        children: (data === null || data === void 0 ? void 0 : (_data$personnels = data.personnels) === null || _data$personnels === void 0 ? void 0 : _data$personnels.length) > 0 ? data === null || data === void 0 ? void 0 : (_data$personnels2 = data.personnels) === null || _data$personnels2 === void 0 ? void 0 : _data$personnels2.map(function (item, index) {
          var _item$name4, _item$name5, _item$country, _item$country$name, _item$religion, _item$name6, _item$job;

          if (item !== null && item !== void 0 && item.available) return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
            xxl: 3,
            lg: 4,
            md: 6,
            sm: 12,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "personnel",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "img",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: (0,functions/* handleImageLink */.Iz)(item === null || item === void 0 ? void 0 : (_item$name4 = item.name) === null || _item$name4 === void 0 ? void 0 : _item$name4.pdfImage),
                  alt: "",
                  width: 500,
                  height: 500
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                  type: "button",
                  className: "pdf-btn",
                  onClick: function onClick() {
                    return handlePdfDownload(item);
                  },
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    src: download/* default */.Z,
                    alt: "",
                    width: 16,
                    height: 16
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "downloadPdf"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                  type: "button",
                  className: "expand-btn",
                  onClick: function onClick() {
                    return handleExpandImage(item);
                  },
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    src: expand/* default */.Z,
                    alt: "",
                    width: 16,
                    height: 16
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "expandImage"
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "info",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  children: item === null || item === void 0 ? void 0 : (_item$name5 = item.name) === null || _item$name5 === void 0 ? void 0 : _item$name5[locale]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: "key",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "nationality"
                      }), ":", " "]
                    }), item === null || item === void 0 ? void 0 : (_item$country = item.country) === null || _item$country === void 0 ? void 0 : (_item$country$name = _item$country.name) === null || _item$country$name === void 0 ? void 0 : _item$country$name[locale]]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: "key",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "code"
                      }), ":"]
                    }), item === null || item === void 0 ? void 0 : item.id]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: "key",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "religion"
                      }), ":", " "]
                    }), item === null || item === void 0 ? void 0 : (_item$religion = item.religion) === null || _item$religion === void 0 ? void 0 : _item$religion[locale]]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: "key",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "experienceYears"
                      }), ":", " "]
                    }), item === null || item === void 0 ? void 0 : (_item$name6 = item.name) === null || _item$name6 === void 0 ? void 0 : _item$name6.experienceYears]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: "key",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "age"
                      }), ":"]
                    }), item === null || item === void 0 ? void 0 : item.age, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                      id: "year"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: "key",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "job"
                      }), ":"]
                    }), item === null || item === void 0 ? void 0 : (_item$job = item.job) === null || _item$job === void 0 ? void 0 : _item$job[locale]]
                  }), (item === null || item === void 0 ? void 0 : item.salary) && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: "key",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "monthlySalary"
                      }), ":"]
                    }), " ", item === null || item === void 0 ? void 0 : item.salary, /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: sar/* default */.Z,
                      alt: "",
                      width: 18,
                      height: 18,
                      className: "mx-1"
                    })]
                  }), (item === null || item === void 0 ? void 0 : item.recruitmentFees) && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: "key",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "recruitmentFees"
                      }), ":"]
                    }), " ", item === null || item === void 0 ? void 0 : item.recruitmentFees, /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: sar/* default */.Z,
                      alt: "",
                      width: 18,
                      height: 18,
                      className: "mx-1"
                    })]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "btns d-flex align-items-center justify-content-between gap-3",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: "open-request-modal nw-btn",
                    onClick: function onClick() {
                      return handleOpenRequestModal(item);
                    },
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                      id: "recruitmentRequest"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                    href: "/personnel/".concat(item === null || item === void 0 ? void 0 : item.id),
                    legacyBehavior: true,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      className: "details-link nw-btn",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "viewDetails"
                      })
                    })
                  })]
                })]
              })]
            })
          }, "personnel" + index);
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
          xs: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "no-data text-center alert alert-info",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "noPersonnels"
            })
          })
        })
      })
    }), expandedImage && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "zoom-image",
      onClick: function onClick() {
        return setExpandedImage("");
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: expandedImage,
        width: 1200,
        height: 1200,
        alt: ""
      })
    }), isRequestOpen && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "request-modal",
      onClick: function onClick() {
        return setIsRequestOpen(false);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "request-modal-content",
        onClick: function onClick(event) {
          return event.stopPropagation();
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "request-modal-header",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "recruitmentRequest"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            className: "request-modal-close",
            onClick: function onClick() {
              return setIsRequestOpen(false);
            },
            "aria-label": "close",
            children: "\xD7"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(RequestForm["default"], {
          countries: data ? [data] : [],
          person: selectedPerson,
          onSuccess: function onSuccess() {
            return setIsRequestOpen(false);
          }
        })]
      })
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/components/helpers/seo.js
var seo = __webpack_require__(540);
;// CONCATENATED MODULE: ./pages/recruitmentCountries/[id].js










var SingleCountryPage = function SingleCountryPage(_ref) {
  var _singleCountry$metaTi, _singleCountry$metaDe, _singleCountry$name, _singleCountry$name2, _singleCountry$name2$;

  var singleCountry = _ref.singleCountry;

  var _useIntl = (0,useIntl/* default */.Z)(),
      locale = _useIntl.locale,
      formatMessage = _useIntl.formatMessage;

  var _useRouter = (0,router.useRouter)(),
      asPath = _useRouter.asPath;

  var _buildSeoAlternates = (0,seo/* buildSeoAlternates */.Rl)(asPath, locale),
      canonical = _buildSeoAlternates.canonical,
      languageAlternates = _buildSeoAlternates.languageAlternates;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: singleCountry === null || singleCountry === void 0 ? void 0 : (_singleCountry$metaTi = singleCountry.metaTitle) === null || _singleCountry$metaTi === void 0 ? void 0 : _singleCountry$metaTi[locale],
      description: singleCountry === null || singleCountry === void 0 ? void 0 : (_singleCountry$metaDe = singleCountry.metaDescription) === null || _singleCountry$metaDe === void 0 ? void 0 : _singleCountry$metaDe[locale],
      canonical: canonical,
      languageAlternates: languageAlternates
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumbs["default"], {
      heading: singleCountry === null || singleCountry === void 0 ? void 0 : (_singleCountry$name = singleCountry.name) === null || _singleCountry$name === void 0 ? void 0 : _singleCountry$name[locale],
      description: "".concat(formatMessage({
        id: "main"
      }), " / ").concat(formatMessage({
        id: "recruitmentCountries"
      }), " / ").concat(singleCountry === null || singleCountry === void 0 ? void 0 : (_singleCountry$name2 = singleCountry.name) === null || _singleCountry$name2 === void 0 ? void 0 : (_singleCountry$name2$ = _singleCountry$name2[locale]) === null || _singleCountry$name2$ === void 0 ? void 0 : _singleCountry$name2$.slice(0, 50))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "wrapper ",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SingleCountry, {
        data: singleCountry
      })
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ var _id_ = (SingleCountryPage);

/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(682);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);







var BreadCrumb = function BreadCrumb(_ref) {
  var _heading$locale, _description$locale;

  var heading = _ref.heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "" : _ref$description;

  var _useIntl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      locale = _useIntl.locale;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      pathname = _useRouter.pathname;

  var shouldHidePath = pathname.startsWith("/blogs/") && pathname !== "/blogs";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: "breads wrapper",
    style: {
      backgroundColor: "rgb(112 96 166 / 100%)"
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "inner",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h1", {
          className: "unique-bold h3",
          children: (_heading$locale = heading === null || heading === void 0 ? void 0 : heading[locale]) !== null && _heading$locale !== void 0 ? _heading$locale : heading
        }), ((description === null || description === void 0 ? void 0 : description[locale]) || (description === null || description === void 0 ? void 0 : description.length) > 0) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ul", {
          children: !shouldHidePath && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
            children: (_description$locale = description === null || description === void 0 ? void 0 : description[locale]) !== null && _description$locale !== void 0 ? _description$locale : description
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);

/***/ }),

/***/ 4266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7794);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7536);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4012);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1555);
/* harmony import */ var _src_api_server__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5981);
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6455);
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var RequestForm = function RequestForm(_ref) {
  var _errors$name, _errors$phone, _errors$email, _errors$message;

  var person = _ref.person,
      onSuccess = _ref.onSuccess;

  var _useIntl = (0,react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(),
      formatMessage = _useIntl.formatMessage,
      locale = _useIntl.locale;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)(),
      query = _useRouter.query;

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_8__/* .useForm */ .cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      errors = _useForm.formState.errors;

  var getLocalizedValue = function getLocalizedValue(field, locale) {
    var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "-";

    if (typeof field === "object" && field !== null) {
      var _field$ar, _field$ar$trim, _field$en, _field$en$trim, _field$locale, _field$locale$trim;

      var ar = field === null || field === void 0 ? void 0 : (_field$ar = field.ar) === null || _field$ar === void 0 ? void 0 : (_field$ar$trim = _field$ar.trim) === null || _field$ar$trim === void 0 ? void 0 : _field$ar$trim.call(_field$ar);
      var en = field === null || field === void 0 ? void 0 : (_field$en = field.en) === null || _field$en === void 0 ? void 0 : (_field$en$trim = _field$en.trim) === null || _field$en$trim === void 0 ? void 0 : _field$en$trim.call(_field$en);
      if (!ar && !en) return fallback;
      var localized = field === null || field === void 0 ? void 0 : (_field$locale = field[locale]) === null || _field$locale === void 0 ? void 0 : (_field$locale$trim = _field$locale.trim) === null || _field$locale$trim === void 0 ? void 0 : _field$locale$trim.call(_field$locale);
      return localized || ar || en || fallback;
    }

    if (typeof field === "string") {
      return field.trim() || fallback;
    }

    return fallback;
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var _person$name, _person$country, _person$name2, _person$name2$experie;

    if (query !== null && query !== void 0 && query.personId) reset({
      message: "\u0645\u0647\u062A\u0645 \u0628\u0627\u0644\u0633\u064A\u0631\u0629 \u0627\u0644\u0630\u0627\u062A\u064A\u0629 \u0643\u0648\u062F ".concat(query === null || query === void 0 ? void 0 : query.personId, " \u0648\u0627\u0644\u0627\u0633\u0645 ").concat(query === null || query === void 0 ? void 0 : query.name)
    });else reset({
      message: "\u0627\u0644\u0627\u0633\u0645: ".concat((person === null || person === void 0 ? void 0 : (_person$name = person.name) === null || _person$name === void 0 ? void 0 : _person$name.ar) || "", "\n        \n\u0627\u0644\u062F\u064A\u0627\u0646\u0629: ").concat(getLocalizedValue(person === null || person === void 0 ? void 0 : person.religion, locale) || "", "\n    \n\u0627\u0644\u0643\u0648\u062F: ").concat((person === null || person === void 0 ? void 0 : person.id) || "", "\n\n\u0627\u0644\u062F\u0648\u0644\u0629: ").concat(getLocalizedValue(person === null || person === void 0 ? void 0 : (_person$country = person.country) === null || _person$country === void 0 ? void 0 : _person$country.name, locale) || "", "\n \n\u0627\u0644\u0639\u0645\u0631: ").concat((person === null || person === void 0 ? void 0 : person.age) || "", "\n\n\u0627\u0644\u0644\u063A\u0629: ").concat(getLocalizedValue(person === null || person === void 0 ? void 0 : person.experience, locale) || "", "\n\n\u0633\u0646\u0648\u0627\u062A \u0627\u0644\u062E\u0628\u0631\u0629: ").concat((person === null || person === void 0 ? void 0 : (_person$name2 = person.name) === null || _person$name2 === void 0 ? void 0 : (_person$name2$experie = _person$name2.experienceYears) === null || _person$name2$experie === void 0 ? void 0 : _person$name2$experie.toString().trim()) || "", "\n\n\u0631\u0633\u0648\u0645 \u0627\u0644\u0627\u0633\u062A\u0642\u062F\u0627\u0645: ").concat((person === null || person === void 0 ? void 0 : person.recruitmentFees) || "", "\n        \n        ")
    });
  }, [query === null || query === void 0 ? void 0 : query.personId, query === null || query === void 0 ? void 0 : query.name, person, reset, locale]);

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(data) {
      return _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              data.personnel = query === null || query === void 0 ? void 0 : query.personId;
              _context.next = 4;
              return _src_api_server__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/requests", data);

            case 4:
              reset();
              onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
              sweetalert2__WEBPACK_IMPORTED_MODULE_4___default().fire("".concat(formatMessage({
                id: "thanks"
              })), "".concat(formatMessage({
                id: "thankMsg"
              })), "success");
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              console.log("error", _context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "order-form",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            xs: "12",
            md: "6",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "form-group",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
                htmlFor: "name",
                children: formatMessage({
                  id: "name"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("input", _objectSpread({
                id: "name",
                className: "form-control"
              }, register("name", {
                required: true
              }))), (errors === null || errors === void 0 ? void 0 : (_errors$name = errors.name) === null || _errors$name === void 0 ? void 0 : _errors$name.type) === "required" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                className: "error-hint",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                  id: "required"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            xs: "12",
            md: "6",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "form-group",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
                htmlFor: "phone",
                children: formatMessage({
                  id: "phone"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("input", _objectSpread(_objectSpread({
                id: "phone",
                className: "form-control"
              }, register("phone", {
                required: true
              })), {}, {
                maxLength: 14,
                type: "text",
                onKeyPress: function onKeyPress(event) {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }
              })), (errors === null || errors === void 0 ? void 0 : (_errors$phone = errors.phone) === null || _errors$phone === void 0 ? void 0 : _errors$phone.type) === "required" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                className: "error-hint",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                  id: "required"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            xs: "12",
            md: "12",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "form-group",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
                htmlFor: "email",
                children: formatMessage({
                  id: "email"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("input", _objectSpread({
                id: "email",
                type: "email",
                className: "form-control"
              }, register("email", {
                required: true
              }))), (errors === null || errors === void 0 ? void 0 : (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.type) === "required" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                className: "error-hint",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                  id: "required"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            xs: "12",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "form-group",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
                htmlFor: "details",
                children: formatMessage({
                  id: "details"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("textarea", _objectSpread(_objectSpread({
                id: "details",
                className: "form-control"
              }, register("message", {
                required: true
              })), {}, {
                rows: "7" // placeholder={formatMessage({
                //   id: "details",
                // })}

              })), (errors === null || errors === void 0 ? void 0 : (_errors$message = errors.message) === null || _errors$message === void 0 ? void 0 : _errors$message.type) === "required" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                className: "error-hint",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                  id: "required"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            xs: "12",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: "form-group button",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
                type: "submit",
                className: "btn gradient-btn",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                  id: "send"
                })
              })
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (RequestForm);

/***/ }),

/***/ 7819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iz": function() { return /* binding */ handleImageLink; },
/* harmony export */   "SI": function() { return /* binding */ htmlToExcerpt; },
/* harmony export */   "zv": function() { return /* binding */ getId; }
/* harmony export */ });
/* unused harmony exports mapBlogForListing, checkRedirect */
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);



var getId = function getId(obj) {
  return (obj === null || obj === void 0 ? void 0 : obj._id) || (obj === null || obj === void 0 ? void 0 : obj.id) || "".concat(obj);
}; // يبني مُقتطف نصي قصير من HTML كامل (يحذف الصور base64 والوسوم) لتفادي تضخيم حجم الصفحة

var htmlToExcerpt = function htmlToExcerpt(html) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  if (!html) return "";
  var withoutImages = String(html).replace(/<img[^>]*>/gi, "");
  var text = withoutImages.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  return text.length > maxLength ? "".concat(text.slice(0, maxLength).trim(), "\u2026") : text;
}; // يحوّل قيمة مترجمة (ar/en) تحتوي HTML كامل إلى نفس الشكل لكن بمقتطف نصي قصير

var localizedExcerpt = function localizedExcerpt(localized, maxLength) {
  if (!localized || typeof localized !== "object") return localized;
  return Object.fromEntries(Object.entries(localized).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        locale = _ref2[0],
        html = _ref2[1];

    return [locale, htmlToExcerpt(html, maxLength)];
  }));
}; // يبني نسخة خفيفة من كائن المدونة لصفحات القوائم، بدون وصف HTML الكامل
// (الذي قد يحتوي صورًا مرفوعة كـ base64 ويُضاعف حجم الصفحة عند تسلسله ضمن __NEXT_DATA__)


var mapBlogForListing = function mapBlogForListing(blog) {
  var _blog$category, _blog$category2, _blog$category3;

  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  return {
    id: (blog === null || blog === void 0 ? void 0 : blog.id) || (blog === null || blog === void 0 ? void 0 : blog._id) || null,
    title: blog === null || blog === void 0 ? void 0 : blog.title,
    image: blog === null || blog === void 0 ? void 0 : blog.image,
    category: blog !== null && blog !== void 0 && blog.category ? {
      id: (blog === null || blog === void 0 ? void 0 : (_blog$category = blog.category) === null || _blog$category === void 0 ? void 0 : _blog$category.id) || (blog === null || blog === void 0 ? void 0 : (_blog$category2 = blog.category) === null || _blog$category2 === void 0 ? void 0 : _blog$category2._id) || null,
      title: (blog === null || blog === void 0 ? void 0 : (_blog$category3 = blog.category) === null || _blog$category3 === void 0 ? void 0 : _blog$category3.title) || null
    } : null,
    createdAt: blog === null || blog === void 0 ? void 0 : blog.createdAt,
    description: localizedExcerpt(blog === null || blog === void 0 ? void 0 : blog.description, maxLength)
  };
};
var handleImageLink = function handleImageLink(image) {
  if (image !== null && image !== void 0 && image.includes("http")) {
    return image;
  } else {
    return "".concat("https://alnojoom.ejjadh.info/", "/").concat(image);
  }
}; // ضع هذا الكود داخل نفس ملف الصفحة

var REDIRECTS_ENDPOINT = "https://alnojoom.ejjadh.info/api/seoRedirects"; // نظّف المسار: فك التشفير + إزالة ?query + إزالة / آخر المسار

function cleanPath() {
  var resolvedUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  try {
    var noQuery = String(resolvedUrl).split("?")[0] || "/";
    var decoded = decodeURI(noQuery);
    return decoded.length > 1 && decoded.endsWith("/") ? decoded.slice(0, -1) : decoded;
  } catch (_unused) {
    var _noQuery = String(resolvedUrl).split("?")[0] || "/";

    return _noQuery.length > 1 && _noQuery.endsWith("/") ? _noQuery.slice(0, -1) : _noQuery;
  }
} // ابنِ Destination مطلق بدون أي Query Params


function toAbsoluteNoQuery(destRaw, req) {
  try {
    if (/^https?:\/\//i.test(destRaw)) {
      var u = new URL(destRaw);
      u.search = "";
      return u.toString();
    }

    var protocol = (req.headers["x-forwarded-proto"] || "").split(",")[0] || (req.socket && req.socket.encrypted ? "https" : "http");
    var host = req.headers.host;
    var path = destRaw.startsWith("/") ? destRaw : "/".concat(destRaw);
    return "".concat(protocol, "://").concat(host).concat(path);
  } catch (_unused2) {
    return String(destRaw).split("?")[0];
  }
}

function checkRedirect(_x, _x2) {
  return _checkRedirect.apply(this, arguments);
}

function _checkRedirect() {
  _checkRedirect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolvedUrl, req) {
    var path, res, json, redirects, hit, permanent;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            path = cleanPath(resolvedUrl);
            _context.prev = 1;
            _context.next = 4;
            return fetch(REDIRECTS_ENDPOINT, {
              headers: {
                Accept: "application/json"
              }
            });

          case 4:
            res = _context.sent;

            if (res.ok) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", null);

          case 7:
            _context.next = 9;
            return res.json();

          case 9:
            json = _context.sent;
            redirects = json && json.data && json.data.seoRedirects || [];
            hit = redirects.find(function (r) {
              return (r === null || r === void 0 ? void 0 : r.source) && (r === null || r === void 0 ? void 0 : r.destination) && cleanPath(r.source) === path;
            });

            if (hit) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", null);

          case 14:
            permanent = String(hit.redirectCode) === "301" || String(hit.redirectCode) === "308";
            return _context.abrupt("return", {
              destination: toAbsoluteNoQuery(String(hit.destination).trim(), req),
              permanent: permanent
            });

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", null);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 18]]);
  }));
  return _checkRedirect.apply(this, arguments);
}

/***/ }),

/***/ 540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rl": function() { return /* binding */ buildSeoAlternates; }
/* harmony export */ });
/* unused harmony exports SITE_URL, DEFAULT_LOCALE, localizedUrl */
// ====== إعدادات الـ SEO المشتركة ======
var SITE_URL = "https://alnjoom.sa";
var DEFAULT_LOCALE = "ar"; // النسخة الافتراضية (x-default) هي العربية
// ينظّف الـ path: يشيل الـ query/hash ويضبط الـ trailing slash

var normalizePath = function normalizePath() {
  var asPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var path = String(asPath).split("?")[0].split("#")[0] || "/";
  if (!path.startsWith("/")) path = "/".concat(path); // مطابقة لإعداد trailingSlash: true في next.config.js

  if (path !== "/" && !path.endsWith("/")) path = "".concat(path, "/");
  return path;
}; // يبني رابط مطلق للّغة المطلوبة (العربية بدون بادئة، الإنجليزية ببادئة /en)


var localizedUrl = function localizedUrl(asPath, locale) {
  var path = normalizePath(asPath); // يبدأ بـ "/" وينتهي بـ "/"

  if (locale === DEFAULT_LOCALE) return "".concat(SITE_URL).concat(path);
  return path === "/" ? "".concat(SITE_URL, "/").concat(locale, "/") : "".concat(SITE_URL, "/").concat(locale).concat(path);
}; // يبني canonical + hreflang (ar / en / x-default) لأي صفحة
// x-default يشير دائمًا للنسخة العربية

var buildSeoAlternates = function buildSeoAlternates(asPath) {
  var currentLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_LOCALE;
  return {
    canonical: localizedUrl(asPath, currentLocale),
    languageAlternates: [{
      hrefLang: "ar",
      href: localizedUrl(asPath, "ar")
    }, {
      hrefLang: "en",
      href: localizedUrl(asPath, "en")
    }, {
      hrefLang: "x-default",
      href: localizedUrl(asPath, DEFAULT_LOCALE)
    }]
  };
};

/***/ }),

/***/ 9596:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruitmentCountries/[id]",
      function () {
        return __webpack_require__(9521);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1476:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/download.b3e7badf.svg","height":20,"width":20});

/***/ }),

/***/ 7571:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/expand.83306eef.svg","height":16,"width":16});

/***/ }),

/***/ 5175:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/sar.f03e266e.svg","height":13,"width":12});

/***/ }),

/***/ 9324:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"countryPage":"singleCountry_countryPage__rzlIv"};

/***/ }),

/***/ 1555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useCol */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





function useCol({
  as,
  bsPrefix,
  className,
  ...props
}) {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'col');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const spans = [];
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;
    if (typeof propValue === 'object' && propValue != null) {
      ({
        span,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });
  return [{
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, ...spans, ...classes)
  }, {
    as,
    bsPrefix,
    spans
  }];
}
const Col = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref) => {
  const [{
    className,
    ...colProps
  }, {
    as: Component = 'div',
    bsPrefix,
    spans
  }] = useCol(props);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ...colProps,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, !spans.length && bsPrefix)
  });
});
Col.displayName = 'Col';
/* harmony default export */ __webpack_exports__["Z"] = (Col);

/***/ }),

/***/ 682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 1608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'row');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;
    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ __webpack_exports__["Z"] = (Row);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8166,2962,2143,1664,3053,9774,2888,179], function() { return __webpack_exec__(9596); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);